import { memo, ReactElement, useCallback, useState } from "react"
import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import Heading from "components/Typography/Heading"
import { useAppSelector } from "reducers/store"
import { useQuery } from "hooks/useQuery"
import { useQueryState } from "context/queryState"
import { BeatTable } from "components/Beat/BeatTable/layout"
import { useDeepMemo } from "utils/useDeepMemo"
import ApiMetrics from "api/ApiMetrics"
import { PRODUCT_FETCH } from "reducers/metrics/metrics-types"
import { columns } from "constants/metrics-table"

interface ContainerProps {
  direction?: string
  align?: string
}

const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.palette.gray_ice};
`

export const Title = styled.span`
  display: flex;
  align-items: center;
  padding: 40px 0px 24px 0px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 24px 24px 0px;
`

const TableSection = styled.div``

interface ProducsPerformanceTableProps {
  filters: App.MetricsParams
}

const ProductsPerformanceTable = (props: ProducsPerformanceTableProps): ReactElement => {
  const { filters } = props

  const navigate = useNavigate()
  const queryParams = useQuery()

  const [skip, setSkip] = useState<string>(queryParams.get("skip") ?? "0")
  const [take, setTake] = useState<string>(queryParams.get("take") ?? "10")

  const memoizedFilters = useDeepMemo(() => filters, [filters])

  const searchFilters = {
    dateStart: filters.dateStart,
    dateEnd: filters.dateEnd,
    productPrefixUrl: filters.productPrefixUrl,
    skip: skip,
    take: take
  }

  useQueryState(
    [PRODUCT_FETCH, searchFilters],
    async () =>
      new ApiMetrics().searchProductsMetrics({
        ...filters,
        skip: Number(skip),
        take: Number(take)
      }),
    PRODUCT_FETCH
  )

  const { productsPerfomance } = useAppSelector((state) => state.metrics)

  const handleNavigate = useCallback(
    (params) => {
      const queries = new URLSearchParams(params.toString().split("?")[1])

      const skip = parseInt(queries.get("skip") ?? "0")
      const take = parseInt(queries.get("take") ?? "10")

      setSkip(skip.toString())
      setTake(take.toString())

      return navigate
    },
    [navigate]
  )

  return (
    <Container direction="column" align="center">
      <Title>
        <Heading variant="h4">Desempenho dos produtos</Heading>
      </Title>
      <Content>
        <TableSection>
          <BeatTable
            columnsjson={columns}
            data={productsPerfomance.products}
            loading={productsPerfomance.loading}
            totalItems={productsPerfomance.totalItems}
            initialPage={Number(skip) / Number(take)}
            initialTake={Number(take)}
            navigate={handleNavigate}
            applyParamsToQuery
            filters={memoizedFilters}
          />
        </TableSection>
      </Content>
    </Container>
  )
}

export default memo(ProductsPerformanceTable)
